export type ReviewSeverity = 'error' | 'warn' | 'info';

export interface FieldReview {
  field: string;
  message: string;
  severity: ReviewSeverity;
}

export interface ExtractedImage {
  id: string;
  url: string;
  source: string;
  /** Original path or meta key reference */
  raw?: string;
}

/** One logical property after parsing CSV */
export interface WpImportProperty {
  wpPostId: string;
  postTitle: string;
  postContent: string;
  postContentHtml: string;
  meta: Record<string, unknown>;
  rawMeta: Record<string, string>;
  images: ExtractedImage[];
  reviews: FieldReview[];
  /** True if any meta_value was PHP-serialized and decoded */
  hadSerializedMeta: boolean;
  selected: boolean;
  /** Image ids from ExtractedImage.id that are selected for upload */
  selectedImageIds: Set<string>;
}

export const REQUIRED_LONG_HEADERS = ['meta_key', 'meta_value'] as const;
export const POST_ID_HEADERS = ['ID', 'post_id', 'post_ID', 'id'] as const;
export const POST_TITLE_HEADERS = ['post_title', 'title', 'Title'] as const;
export const POST_CONTENT_HEADERS = ['post_content', 'content', 'Content'] as const;
